export default __webpack_public_path__ + "static/media/app-store-icon.15eb46f8.png";